import { redirect } from 'react-router-dom';
import type { AxiosError } from 'axios';
import axiosInstance, { getAxiosErrorMessage } from '../axiosInstance';
import type { ApiResponse } from '../services.types';
import { store } from '@/store';
import usersApi from '../../features/UserManagement/services/usersApi';

export const redirectToPotatoLogin = (): void => {
  window.location.href = `${import.meta.env.VITE_API_BASE_URL}/auth/potato`;
};

export const verifyAuthToken = async (authToken: string) => {
  try {
    const response = await axiosInstance.post('/auth/set-tokens', { token: authToken });
    return response.data;
  } catch (error) {
    console.error('Error verifying auth token:', error);
    throw error;
  }
};

export const verifyRoleInvitationToken = async (token: string, action: string) => {
  try {
    const response = await axiosInstance.post(`/user-management/invitations/respond`, {
      token,
      action,
    });
    return response.data;
  } catch (error) {
    console.error('Error verifying role invitation token:', error);
    const axiosError = error as AxiosError<{ data?: unknown; message?: string }>;
    throw new Error(
      getAxiosErrorMessage(
        axiosError.response?.data,
        'This invitation link is invalid or has expired.'
      ),
      { cause: error }
    );
  }
};

export const logout = async (): Promise<ApiResponse<{ success: boolean; message: string }>> => {
  const response = await axiosInstance.post('/auth/logout');
  return response.data;
};

export const isAuthenticated = async () => {
  const result = await store.dispatch(
    usersApi.endpoints.getUserProfile.initiate(undefined, {
      subscribe: false,
    })
  );
  if ('error' in result || !result.data?.user) {
    throw redirect('/login');
  }
  return result.data;
};

export const testLogin = async (email: string, password: string) => {
  const response = await axiosInstance.post('/auth/test-login', {
    email,
    password,
  });
  return response.data;
};

export const validateExternalAuditorSetupToken = async (token: string) => {
  const response = await axiosInstance.post('/auth/external-auditor/setup/validate', { token });
  return response.data;
};
